import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { RoleDtoRole } from '@/generated/model';

import { getRoleLabel } from '../../utils/roleUtils';

type RoleChipProps = {
  role: RoleDtoRole;
  isUserDeactivated: boolean;
};

export function RoleChip({ role, isUserDeactivated }: RoleChipProps) {
  const { t } = useTranslation();

  return (
    <Chip
      label={getRoleLabel(t, role)}
      size="small"
      sx={{ width: 'fit-content', color: isUserDeactivated ? 'text.disabled' : 'unset' }}
    />
  );
}
